export const MarketingHome = () => {
  return (
    <div>
      This will be the marketing homesite.
    </div>
  )
}